export enum ShippingMethodEnum {
    Online = 'online',
    Express = 'express',
    Standard = 'standard',
    BoxExpress = 'box_express',
    BoxStandard = 'box_standard',
}

export enum PaymentMethod {
    PayPal = 'paypal',
}

export type PaymentSession = {
    orderId: string;
    paypalOrderId?: string;
    paymentTransactionId?: string;
};
